"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reviewInputInfoReducer;

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var initialState = (0, _immutable.fromJS)({
  goodId: null,
  parentId: null,
  goodName: '',
  open: false,
  submitReviewStatus: _RequestStatusTypes.default.UNINITIALIZED,
  transactionId: null
});

function reviewInputInfoReducer() {
  var reviewInputInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.REVIEW_MODAL_OPENED:
      return reviewInputInfo.merge({
        open: true,
        goodId: action.payload.goodId,
        parentId: action.payload.parentId || '',
        goodName: action.payload.goodName,
        submitReviewStatus: _RequestStatusTypes.default.UNINITIALIZED,
        transactionId: action.payload.transactionId
      });

    case _ActionTypes.default.DISMISSED_REVIEW_MODAL:
      return initialState;

    case _ActionTypes.default.REVIEW_SUBMITTED:
      if (action.error) {
        return reviewInputInfo.set('submitReviewStatus', _RequestStatusTypes.default.FAILED);
      }

      return reviewInputInfo.set('submitReviewStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.REVIEW_SUBMITTED_FROM_DETAILS_SUCCESS:
    case _ActionTypes.default.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS:
      return reviewInputInfo.set('submitReviewStatus', _RequestStatusTypes.default.SUCCEEDED);

    default:
      return reviewInputInfo;
  }
}

module.exports = exports.default;